













import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * The frame of a Mira breakdown: a title, what it is based on, the breakdown itself (the slot), and
 * the figure's caveat. `empty` replaces the breakdown with "Keine Daten im Zeitraum" when the chosen
 * period does not publish the figure.
 */
@Component
export default class MiraDetailCardComponent extends Vue {
  @Prop({ required: true })
  title!: string;

  @Prop({ default: null })
  subtitle!: string | null;

  @Prop({ default: null })
  caveat!: string | null;

  @Prop({ default: false })
  empty!: boolean;
}
